import type { StarsButtonProps } from '@ps/web-shared-components';
import { StarsButton as Button, Link, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import Arrow from '@swf/core/assets/icons/arrow.svg';

import { TXTCLI_More } from './CasinoAllButton.messages.json';
import styles from './CasinoAllButton.scss';

const CasinoAllButton: React.FC<StarsButtonProps> = (props) => (
  <>
    <Link {...props} className={classNames(styles.allLink, props.className)}>
      <Translation {...TXTCLI_More} />
      <Arrow />
    </Link>
    <Button
      {...props}
      data-testid="more-button-from-rapid-streams"
      variant="casino"
      size="small"
      className={classNames(styles.allButton, props.className)}
      translation={TXTCLI_More}
    />
  </>
);

export default CasinoAllButton;
